var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'lupe')?_c('img',{staticClass:"lupe-icon",attrs:{"src":require("../../../../images/viluu/icon/lupe.svg"),"alt":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }